import * as React from 'react';
import * as moment from 'moment';

interface Props {
  date: string;
  email: string;
  subject: string;
  status: string;
  currentMail: boolean;
}

const CommunicationBody = ({ currentMail, email, subject, status, date }: Props) => {

  if (currentMail) {
    return(
      <div className='d-flex'>
        <div className='second-communication communication-body'>{email}</div>
        <div className='third-communication communication-body'>{subject}</div>
        <div className='fourth-communication communication-body'>{status}</div>
        <div className='first-communication communication-body'>{moment(date).format('YYYY-MM-DD')}</div>
      </div>
    );
  } else {
    return(
      <div className='d-flex'>
        <div className='second-communication communication-body history-mail'>
          {email}
        </div>
        <div className='third-communication communication-body history-mail'>
          {subject}
        </div>
        <div className='first-communication communication-body history-mail'>
          {moment(date).format('YYYY-MM-DD')}
        </div>
      </div>
    );
  }
};

export default React.memo(CommunicationBody);
